import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useNotifications(filters = {}) {
  const { token, user, reload } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchNotifications() {
    setLoading(true);
    const { response, data } = await API.fetchNotifications(token, user.id);

    if (response.ok) {
      setResult(data);
      setLoading(false);
      reload();
    }
  }

  const onRefresh = useCallback(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    fetchNotifications()
  }, [user.id]);

  return {
    loading,
    notifications: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
    refresh: onRefresh,
  };
}
